import { Button, TextField, ThemeProvider, createTheme, styled, useTheme } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { type MovieFormikValues, type TvFormikValues, type UseFormik } from '#components/Filters/types.ts';
import { InputLabelWithCheckbox } from '#components/Form/InputLabelWithCheckbox/index.tsx';
import { type DiscoverMovieFilters, type DiscoverTvFilters } from '#types.ts';

export const Container = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grey[900],
  borderTop: `1px solid ${theme.palette.grey[800]}`,
  bottom: 0,
  left: 0,
  marginLeft: `-${theme.spacing(1)}`,
  marginTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingTop: theme.spacing(2),
  position: 'sticky',
  width: `calc(100% + ${theme.spacing(2)})`,
}));

export type FormActionsProps = {
  filtersParam: DiscoverMovieFilters | DiscoverTvFilters;
  formik: UseFormik<(MovieFormikValues | TvFormikValues) & { addToShortcuts: boolean; shortcutName: string }>;
  setFiltersParam: (value?: DiscoverMovieFilters | DiscoverTvFilters) => void;
  setOpenFiltersDrawer: (value: boolean) => void;
};

export const FormActions = ({ filtersParam, formik, setFiltersParam, setOpenFiltersDrawer }: FormActionsProps) => {
  const theme = useTheme();

  return (
    <Container>
      {formik.values.addToShortcuts ? (
        <ThemeProvider theme={createTheme({ ...theme, palette: { mode: 'dark' } })}>
          <TextField
            aria-label="Shortcut name"
            error={!!formik.errors.shortcutName && !!formik.touched.shortcutName}
            fullWidth
            helperText={
              !!formik.errors.shortcutName && !!formik.touched.shortcutName ? formik.errors.shortcutName : undefined
            }
            hiddenLabel
            name="shortcutName"
            onChange={formik.handleChange}
            placeholder="Enter shortcut name"
            sx={{ marginBottom: theme.spacing(1) }}
          />
        </ThemeProvider>
      ) : undefined}
      <InputLabelWithCheckbox
        checked={formik.values.addToShortcuts}
        id="add-to-shortcuts-label"
        inputProps={{
          name: 'addToShortcuts',
        }}
        onChange={formik.handleChange}
        sx={{ marginTop: 0 }}
      >
        Add to shortcuts
      </InputLabelWithCheckbox>
      <Button color="primary" fullWidth type="submit" variant="contained">
        Apply
      </Button>
      <Button
        color="inherit"
        fullWidth
        onClick={() => {
          if (isEmpty(filtersParam)) {
            return;
          }

          setFiltersParam();
          setOpenFiltersDrawer(false);
        }}
        sx={{ color: theme.palette.grey[900], marginTop: theme.spacing(1) }}
        variant="contained"
      >
        Clear
      </Button>
    </Container>
  );
};
